export default __webpack_public_path__ + "static/media/36I-117168_-37370_0.2ea583a2.jpg";